import { render, staticRenderFns } from "./DashboardPizzaPainelSustentabilidade.vue?vue&type=template&id=693cc97e&"
import script from "./DashboardPizzaPainelSustentabilidade.vue?vue&type=script&lang=js&"
export * from "./DashboardPizzaPainelSustentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPizzaPainelSustentabilidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
